import styles from "./SignOutConfirmationPopUp.module.css";
import { Link } from "react-router-dom";
import { usePostHog } from 'posthog-js/react';
import axios from "axios";
import { trackAuthEvent, AUTH_EVENT_TYPES } from '../../utils/analyticsService';

export const SignOutConfirmationPopUp = ({toggleModal})=>{
    const posthog = usePostHog();

    const handleSignOut = () => {
        axios.defaults.headers.common.Authorization = undefined;
        // Use centralized analytics for logout tracking
        trackAuthEvent(AUTH_EVENT_TYPES.LOGOUT, {
            phone: localStorage.getItem('phoneNo'),
            method: 'manual_logout'
        });
        
        // Reset PostHog user identification
        if (posthog) {
            posthog.reset(true);
        }
        
        // Clear all user-related data
        localStorage.removeItem('accesstoken');
        localStorage.removeItem('phoneNo');
        localStorage.removeItem('brandId');
        localStorage.removeItem('bundleId');
        localStorage.removeItem('bundleName');
        localStorage.clear();
        toggleModal();
    }

    return(
        <div className={styles.overlay} onClick={toggleModal}>
            <div className={styles.popUp} onClick={(e)=>{
                e.stopPropagation()
            }}>
                <p className={styles.text}>Are you sure you want to sign out?</p>
                <div className={styles.buttonContainer}>
                    <button onClick={toggleModal} className={styles.cancelButton}>CANCEL</button>
                    <Link to={"/login"} onClick={handleSignOut} className={styles.logOutButton}>SIGN OUT</Link>
                </div>
            </div>
        </div>
    )
}